<template>
  <vs-row vs-type="flex" vs-w="12">
    <!-- Summary Cards -->
    <vs-row id="reportSummaryCards" vs-type="flex" vs-w="12" class="mt-4" vs-align="center" vs-justify="space-between">
      <vs-col vs-type="flex" vs-sm="12" vs-w="5.9" class="bg-white py-3 px-2 my-1 sale-box-shadow low-border-radius">
        <vs-row vs-type="flex" vs-w="12">
          <vs-col vs-type="flex" class="w-auto" vs-align="center">
            <vs-button size="large" radius icon-pack="pickicon" class="amountChip" color="transparent" icon="icon-rich"/>
          </vs-col>
          <vs-col vs-type="flex" vs-w="9" class="pl-2" vs-align="center">
            <vs-row vs-type="flex" vs-w="12">
              <vs-row vs-type="flex" vs-w="12">
                <span class="text-medium-small2 bold" style="color:#51C2C2;">
                  {{ totalAmount ? $convertCurrency(totalAmount) : "₺0,00" }}
                </span>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12">
                <span class="text-secondary text-xsmall weight-600">Toplam Tutar</span>
              </vs-row>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col vs-type="flex" vs-sm="12" vs-w="5.9" class="bg-white py-3 px-2 my-1 sale-box-shadow low-border-radius">
        <vs-row vs-type="flex" vs-w="12">
          <vs-col vs-type="flex" vs-w="w-auto" vs-align="center">
            <vs-button size="large" class="quantityChip" radius icon-pack="pickicon" icon="icon-products" color="transparent"/>
          </vs-col>
          <vs-col vs-type="flex" vs-w="9" class="pl-2" vs-align="center">
            <vs-row vs-type="flex" vs-w="12">
              <vs-row vs-type="flex" vs-w="12">
                <span class="text-medium-small2 bold" style="color:#FF3D67;">
                  {{ totalQuantity ? (totalQuantity.toLocaleString() + ' Adet') : "0 Adet" }}
                </span>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12">
                <span class="text-secondary text-xsmall weight-600">Toplam Miktar</span>
              </vs-row>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>

    <!-- Data Table -->
    <vs-row vs-type="flex" vs-w="12" class="mt-4 bg-white px-2 pt-4 sale-box-shadow low-border-radius">
      <vs-table :data="items" class="w-full" noDataText="Kayıt Bulunamadı" compact>
        <template slot="thead">
          <vs-th style="width: 140px">İşlem Tarihi</vs-th>
          <vs-th style="width: 180px">Personel</vs-th>
          <vs-th style="width: 130px; justify-content: center;">İşlem</vs-th>
          <vs-th style="width: 120px">Masa</vs-th>
          <vs-th style="width: 120px">Hedef Masa</vs-th>
          <vs-th style="width: 100px">Sipariş No</vs-th>
          <vs-th style="min-width: 200px">Ürün</vs-th>
          <vs-th style="width: 60px">Adet</vs-th>
          <vs-th style="width: 100px">Birim Fiyat</vs-th>
          <vs-th style="width: 100px">Toplam</vs-th>
          <vs-th style="min-width: 300px">Açıklama</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data" class="text-smaller">
            <vs-td style="width: 140px">{{ tr.createdString || '-' }}</vs-td>
            <vs-td style="width: 180px; font-weight: 500;">{{ tr.userName }}</vs-td>
            <vs-td style="width: 130px; text-align: center;">
                <vs-chip :color="getActionColor(tr.actionType)" class="m-0 w-full justify-center" transparent>
                    {{ getActionName(tr.actionType) }}
                </vs-chip>
            </vs-td>
            <vs-td style="width: 120px">{{ tr.tableName }}</vs-td>
            <vs-td style="width: 120px">{{ tr.toTableName || '-' }}</vs-td>
            <vs-td style="width: 100px">{{ tr.orderId || '-' }}</vs-td>
            <vs-td style="min-width: 200px; font-weight: 500;">{{ tr.productName }}</vs-td>
            <vs-td style="width: 60px; text-align: center;">{{ tr.quantity }}</vs-td>
            <vs-td style="width: 100px">{{ $convertCurrency(tr.price) }}</vs-td>
            <vs-td style="width: 100px; font-weight: 600;">{{ $convertCurrency(tr.totalPrice) }}</vs-td>
            <vs-td style="font-size: 11px; line-height: 1.2; min-width: 300px; color: #666;">{{ tr.description || '-' }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-row>
  </vs-row>
</template>

<script>
export default {
  name: 'staff-action-report-min',
  props: {
    items: { type: Array, default: () => [] },
    totalAmount: { type: Number, default: 0 },
    totalQuantity: { type: Number, default: 0 }
  },
  methods: {
    getActionName(type) {
      const types = {
        'Add': 'Ekleme',
        'Ekleme': 'Ekleme',
        'Cancel': 'İptal',
        'İptal': 'İptal',
        'Transfer': 'Transfer',
        'Merge': 'Birleştirme',
        'Birleştirme': 'Birleştirme',
        'Separation': 'Ayırma',
        'Ayırma': 'Ayırma',
        'Discount': 'İndirim',
        'İndirim': 'İndirim',
        'Treat': 'İkram',
        'İkram': 'İkram',
        'Update': 'Güncelleme',
        'Güncelleme': 'Güncelleme',
        'ChangePaymentMethod': 'Ödeme Şekli Değişimi',
        'TimeChange': 'Süre Değişimi',
        'Süre Değişimi': 'Süre Değişimi'
      };
      return types[type] || type;
    },
    getActionColor(type) {
      const colors = {
        'Add': '#28C76F',         // Yeşil (Success)
        'Ekleme': '#28C76F',
        'Cancel': '#EA5455',      // Kırmızı (Danger)
        'İptal': '#EA5455',
        'Transfer': '#7367F0',    // Mor
        'Merge': '#00CFE8',       // Turkuaz
        'Birleştirme': '#00CFE8',
        'Separation': '#FF9F43',  // Turuncu
        'Ayırma': '#FF9F43',
        'Discount': '#FF4C8B',    // PembeMor
        'İndirim': '#FF4C8B',
        'Treat': '#1E1E1E',       // Siyah (İkram)
        'İkram': '#1E1E1E',
        'Update': '#7367F0',      // Mor (Update)
        'Güncelleme': '#7367F0',
        'ChangePaymentMethod': '#8C52FF', // Morumsu Mavi (Ödeme Değişikliği)
        'TimeChange': '#FE7A36', // Turuncu / Mercan (Süre Değişikliği)
        'Süre Değişimi': '#FE7A36'
      };
      return colors[type] || '#82868B';
    }
  }
}
</script>

<style scoped>
.amountChip { border: 1px solid #51C2C2 !important; color: #51C2C2 !important; }
.quantityChip { border: 1px solid #FF3D67 !important; color: #FF3D67 !important; }
.bold { font-weight: bold; }
</style>
